import type { ReactNode } from "react";
import PublicHeader from "../../../components/PublicHeader";
import PublicFooter from "../../../components/PublicFooter";
import Hero from "./Hero";
import Article, { type ArticleSection } from "./Article";
import FaqSection, { type FaqItem } from "./FaqSection";
import ClosingCta from "./ClosingCta";
import InternalCrossLinks, { type CrossLink } from "./InternalCrossLinks";

type Props = {
  eyebrow: string;
  h1: ReactNode;
  lead: ReactNode;
  sections: ArticleSection[];
  faqs: FaqItem[];
  crossLinks: CrossLink[];
};

// Wrapper layout shared by every marketing landing page. Keeps the editorial
// brand consistent: paper-bg, 760px column on desktop, end-CTA, footer.
export default function MarketingPage({
  eyebrow,
  h1,
  lead,
  sections,
  faqs,
  crossLinks,
}: Props) {
  return (
    <div className="paper-bg" style={{ minHeight: "100vh" }}>
      <PublicHeader />
      <main
        style={{
          maxWidth: 760,
          margin: "0 auto",
          padding: "12px 22px 30px",
          fontFamily: "var(--f-body)",
          color: "var(--ink)",
        }}
      >
        <Hero eyebrow={eyebrow} h1={h1} lead={lead} />
        <Article sections={sections} />
        <FaqSection items={faqs} />
        <InternalCrossLinks links={crossLinks} />
      </main>
      <ClosingCta />
      <PublicFooter />
    </div>
  );
}
